module.exports = __webpack_public_path__ + "img/2_hsgeoje.a8eda131.jpg";